export const REDUCER_NAME = 'DetailsContainer'

export const actions = {
  ui: {
    START_LOADING: 'DetailsContainer/STOP_LOADING',
    STOP_LOADING: 'DetailsContainer/STOP_LOADING',
  },

  data: {
    FETCH: 'DetailsContainer/FETCH',
    FETCH_SUCCESS: 'DetailsContainer/FETCH_SUCCESS',
    FETCH_FAILURE: 'DetailsContainer/FETCH_FAILURE',
  },

  CLEAR_ERRORS: 'DetailsContainer/CLEAR_ERRORS',
  SWITCH_TAB: 'DetailsContainer/SWITCH_TAB',
  RESET_TAB: 'DetailsContainer/RESET_TAB',
}

export const factoryActions = {
  REGISTER: 'DetailsContainer/REGISTER',
  UNREGISTER: 'DetailsContainer/UNREGISTER',
  RESET: 'DetailsContainer/RESET',

  RESET_TYPE: 'DetailsContainer/RESET_TYPE',
  REGISTER_TYPE: 'DetailsContainer/REGISTER_TYPE',
  UNREGISTER_TYPE: 'DetailsContainer/UNREGISTER_TYPE',
}

export const InstanceTypes = {
  Client: 'Client',
  Application: 'Application',
  Collateral: 'Collateral',
  Loan: 'Loan',

  Account: 'Account',
  AccountStatement: 'AccountStatement',
  AccountDebit: 'AccountDebit',
  AccountCredit: 'AccountCredit',

  Order: 'Order',
  OrderView: 'OrderView',
}

export const DetailsGridPrefixes = {
  client: 'ClientDetails-a31d',
  application: 'ApplicationDetails-b38l',
  loan: 'LoanDetails-a21k',
  collateral: 'CollateralDetails-j51q',
  order: 'OrderDetails-f15h',
  statement: 'AccountStatementDetails-k12u',
  account: 'AccountDetails-a31d',
}
